import React from 'react';
import './Section.scss';
import heroImage from '../../assets/image/phone/iPhone1.webp';
import { useLanguage } from '../../context/LanguageContext';
import useInView from '../../hooks/useInView';
import { ANIMATION_CONFIG, ANIMATION_CLASSES } from '../../constants/animation';
import { SECTIONS } from '../../constants/links';

import YouTube from '../../assets/image/icons/Social Icons.svg';
import Discord from '../../assets/image/icons/Social Icons-1.svg';
import Instagram from '../../assets/image/icons/Social Icons-2.svg';
import Telegram from '../../assets/image/icons/Social Icons-3.svg';
import X from '../../assets/image/icons/Social Icons-5.svg';
import Facebook from '../../assets/image/icons/Social Icons-4.svg';
import { APP_LINKS } from '../../constants/links';
import { track } from '../../utils/analytics';

const Section = () => {
  const { t } = useLanguage();
  const [textRef, textInView] = useInView({ threshold: ANIMATION_CONFIG.THRESHOLD.HIGH });
  const [imageRef, imageInView] = useInView({ threshold: ANIMATION_CONFIG.THRESHOLD.HIGH });

  const socialLinks = [
    { icon: YouTube, url: APP_LINKS.SOCIAL.YOUTUBE, alt: 'YouTube', size: 30 },
    { icon: Discord, url: APP_LINKS.SOCIAL.DISCORD, alt: 'Discord', size: 30 },
    { icon: Instagram, url: APP_LINKS.SOCIAL.INSTAGRAM, alt: 'Instagram', size: 30 },
    { icon: Telegram, url: APP_LINKS.SOCIAL.TELEGRAM, alt: 'Telegram', size: 30 },
    { icon: X, url: APP_LINKS.SOCIAL.X, alt: 'X', size: 30 },
    { icon: Facebook, url: APP_LINKS.SOCIAL.FACEBOOK, alt: 'Facebook', size: 30 },
  ];

  return (
    <section className="section" id={SECTIONS.SOCIALS}>
      <div className="section__content">
        <div
          ref={textRef}
          className={`section__text-content ${textInView ? `${ANIMATION_CLASSES.FADE_IN_RIGHT} ${ANIMATION_CLASSES.ANIMATED}` : ANIMATION_CLASSES.HIDDEN}`}
        >
          <h2 className="section__title">
            {t('sectionTitle')}
          </h2>

          <p className="section__description">
            {t('sectionDescription')}
          </p>

          <div className="section__icons">
            {socialLinks.map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => track('social_click', { network: link.alt.toLowerCase() })}
                aria-label={`Follow StranGen Group on ${link.alt}`}
              >
                <img src={link.icon} alt="" width={link.size} height={link.size} />
              </a>
            ))}
          </div>

        </div>

        <div
          ref={imageRef}
          className={`section__image-wrapper ${imageInView ? `${ANIMATION_CLASSES.FADE_IN_LEFT} ${ANIMATION_CLASSES.ANIMATED}` : ANIMATION_CLASSES.HIDDEN}`}
          style={{ animationDelay: ANIMATION_CONFIG.DELAY.LONG }}
        >
          <img
            src={heroImage}
            alt="Hero Arena game screen displayed on a phone"
            className="section__image"
            width={929}
            height={580}
          />
        </div>
      </div>
    </section>
  );
};

export default Section;
